import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    }, null, -1)
  ]))]))
}
export default { render: render }